import React, {Component} from 'react';
import './PlannerOverviewScreen.css';
import PortalScreen from "../PortalScreen";
import Tabber from "../Parts/Tabber";
import TabberTab from "../Parts/TabberTab";
import axios from 'axios';
import ProgressIndicator from "../Parts/ProgressIndicator";
import RmButton from "../../Common/RmButton";
import PlanItemListManaged from "./PlanItemListManaged";
import PlanItemDialog from "../Dialog/PlanItemDialog";
import PlannerDayCalendar from "./PlannerDayCalendar";
import PlanItemDeleteDialog from "../Dialog/PlanItemDeleteDialog";
import PropTypes from 'prop-types';
import {Redirect} from 'react-router-dom';
import ArrowLink from "../../Common/ArrowLink";
import PlanItemDragList from "./PlanItemDragList";
import SafeDateTimeParser from "../../Etc/SafeDateTimeParser";
import moment from 'moment';
import PdfFontEmbeds from "../../Etc/PdfFontEmbeds";

const { PDFExport, savePDF } = require('@progress/kendo-react-pdf');

export default class PlannerOverviewScreen extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loadingOverview: false,
            activeTab: null,
            tasks: [],
            counts: {},
            niceTitle: "Uitvaart taken",

            creatingTask: false,
            editTask: null,
            deleteTask: null,

            prefillStart: null,
            prefillEnd: null,
            prefillText: null,

            needsSeeding: false,
            savingSeeds: false,

            redirectTo: null,

            selectedDragTask: null,
            seedTask: null,

            autoCreate: false,

            renderingPdf: false
        };

        this.refPdf = React.createRef();
    }

    componentDidMount() {
        this.refreshOverview(this.props);
    }

    componentWillReceiveProps(nextProps) {
        this.refreshOverview(nextProps);
    }

    refreshOverview(props) {
        if (this.state.loadingOverview) {
            return;
        }

        if (!props) {
            props = this.props;
        }

        let nextTab = props.match.params.tab || PlannerOverviewScreen.TAB_DEFAULT;

        if (nextTab !== this.state.activeTab) {
            this.setState({
                activeTab: nextTab,
                niceTitle: PlannerOverviewScreen.NICE_TITLE_MAP[nextTab],
                editTask: null,
                creatingTask: false,
                deleteTask: null
            });
        }

        this.setState({
            loadingOverview: true,
            tasks: [],
            counts: {},
            needsSeeding: false,
            savingSeeds: false,
            selectedDragTask: null,
            seedTask: null,
            autoCreate: false,
            renderingPdf: false
        });

        if (this.props.seedMode) {
            let apiUrl = `/tasks/seeds/${nextTab}`;

            axios.get(apiUrl)
                .then((res) => {
                    let data = res.data;

                    if (data.ok) {
                        this.setState({
                            tasks: data.tasks,
                            needsSeeding: true
                        });
                    }
                })
                .catch((err) => {
                    console.error('Planner, seed task overview, GET failure:', nextTab, err);
                })
                .then(() => {
                    this.setState({
                        loadingOverview: false
                    });
                });
        } else {
            let apiUrl = `/tasks/overview/${nextTab}`;

            axios.get(apiUrl)
                .then((res) => {
                    let data = res.data;

                    if (data.ok) {
                        this.setState({
                            tasks: data.tasks,
                            counts: data.counts,
                            needsSeeding: !data.seeded
                        });
                    }
                })
                .catch((err) => {
                    console.error('Planner, task overview, GET failure:', nextTab, err);
                })
                .then(() => {
                    this.setState({
                        loadingOverview: false
                    });
                });
        }
    }

    handleCreateTaskClick() {
        if (this.state.loadingOverview) {
            return;
        }

        this.setState({
            editTask: null,
            creatingTask: true,
            deleteTask: null,
            prefillStart: null,
            prefillEnd: null,
            prefillText: null,
            seedTask: null,
            autoCreate: false
        });
    }

    handleEditorClose(anyChanges) {
        this.setState({
            editTask: null,
            creatingTask: false,
            deleteTask: null,
            prefillStart: null,
            prefillEnd: null,
            prefillText: null,
            autoCreate: false
        });

        if (anyChanges) {
            this.refreshOverview();
        }
    }

    handleTaskChecked(task, isComplete) {
        if (this.state.loadingOverview) {
            return;
        }

        let nextTaskList = this.state.tasks;
        let nextCounts = this.state.counts;

        for (let i = 0; i < nextTaskList.length; i++) {
            let _task = nextTaskList[i];

            if (_task.id === task.id) {
                let wasChecked = !!_task.is_complete;

                if (wasChecked !== isComplete) {
                    _task.is_complete = isComplete;

                    if (wasChecked && !isComplete) {
                        nextCounts.completed--;
                    } else if (!wasChecked && isComplete) {
                        nextCounts.completed++;
                    }
                }
            }
        }

        nextCounts.percentage = (nextCounts.completed / nextCounts.total);

        this.setState({
            editTask: null,
            creatingTask: false,
            taskList: nextTaskList,
            deleteTask: null
        });
    }

    handleTaskClick(task) {
        if (this.state.loadingOverview) {
            return;
        }

        this.setState({
            editTask: task,
            creatingTask: false,
            deleteTask: null,
            prefillStart: null,
            prefillEnd: null,
            prefillText: null,
            autoCreate: false
        });
    }

    handleTaskDeleteClick(task) {
        if (this.state.loadingOverview) {
            return;
        }

        this.setState({
            editTask: null,
            creatingTask: false,
            deleteTask: task,
            autoCreate: false
        });
    }

    handleDeleteCancel() {
        this.setState({
            deleteTask: null
        });
    }

    handleDeleteComplete() {
        this.setState({
            deleteTask: null
        });

        this.refreshOverview();
    }

    handleTaskBgSave() {
        this.refreshOverview();
    }

    handlePeriodSelectForCreate(startDt, endDt) {
        this.setState({
            editTask: null,
            creatingTask: true,
            prefillStart: startDt,
            prefillEnd: endDt,
            deleteTask: null,
            autoCreate: false
        });

        if (this.state.selectedDragTask) {
            this.setState({
                prefillText: this.state.selectedDragTask.name,
                seedTask: this.state.selectedDragTask.seed || null
            });
        }
    }

    handleEventInsertOnCal(task, startTime, endTime) {
        this.setState({
            editTask: null,
            creatingTask: true,
            prefillStart: SafeDateTimeParser.parseToMoment(startTime),
            prefillEnd: SafeDateTimeParser.parseToMoment(endTime),
            prefillText: task.name,
            seedTask: task.seed || null,
            deleteTask: null,
            autoCreate: true
        });
    }

    handleSeedSaveClick() {
        if (this.state.savingSeeds) {
            return;
        }

        this.setState({
            savingSeeds: true
        });

        axios.post(`/tasks/seeds/${this.state.activeTab}`)
            .then(() => {
                this.setState({
                    redirectTo: `/draaiboek/${this.state.activeTab}`,
                    needsSeeding: false
                });

                setTimeout(() => {
                    this.setState({
                        redirectTo: null
                    });
                }, 0);
            });
    }

    handleTipsClick() {
        this.setState({
            redirectTo: `/draaiboek/${this.state.activeTab}/start`,
            needsSeeding: true,
            loadingOverview: true
        });

        setTimeout(() => {
            this.setState({
                redirectTo: null
            });
        }, 0);
    }

    handleDragListItemSelected(task, isDoubleClick) {
        if (!task) {
            this.setState({
                selectedDragTask: null,
                seedTask: null
            });

            return;
        }

        if (isDoubleClick) {
            this.setState({
                editTask: null,
                creatingTask: true,
                prefillStart: null,
                prefillEnd: null,
                deleteTask: null,
                seedTask: task.seed || null,
                selectedDragTask: task,
                prefillText: task.name,
                autoCreate: false
            });
        } else {
            if (this.state.selectedDragTask === task) {
                this.setState({
                    selectedDragTask: null,
                    seedTask: null,
                    autoCreate: false
                });
            } else {
                this.setState({
                    selectedDragTask: task,
                    seedTask: task.seed || null,
                    autoCreate: false
                });
            }
        }
    }

    // -------------------------------------------------------------------------------------------------------------

    handlePdfLinkClick() {
        this.setState({
            renderingPdf: true
        });

        setTimeout(() => {
            this.generatePdf()
                .then(() => {
                    this.setState({
                        renderingPdf: false
                    });
                })
                .catch((err) => {
                    console.error('PDF gen failed:', err);

                    this.setState({
                        renderingPdf: false
                    });

                    alert('Er ging iets mis bij het genereren van de PDF.');
                });
        }, 0);
    }

    generatePdf() {
        return new Promise((resolve, reject) => {
            // OK, so: The first generation tends to fail. So if this is the first time, do it all over again.
            setTimeout(() => {
                try {
                    this.refPdf.save();
                    return resolve();
                } catch (e) {
                    return reject(e);
                }
            }, 1000);
        });
    }

    get pdfName() {
        const dateStamp = moment().format('YMMDD_HHmm');
        return `draaiboek_${this.state.activeTab}_${dateStamp}.pdf`;
    }

    // -----------------------------------------------------------------------------------------------------------------
    // -----------------------------------------------------------------------------------------------------------------
    // -----------------------------------------------------------------------------------------------------------------


    render() {
        // -------------------------------------------------------------------------------------------------------------

        if (this.state.redirectTo) {
            return <Redirect to={this.state.redirectTo}/>;
        }

        // -------------------------------------------------------------------------------------------------------------

        if (!this.props.seedMode && this.state.needsSeeding) {
            return <Redirect to={`/draaiboek/${this.state.activeTab}/start`}/>;
        }

        // -------------------------------------------------------------------------------------------------------------

        let tasksForList = this.state.tasks || [];
        let tasksForDrag = [];

        if (this.state.activeTab === PlannerOverviewScreen.TAB_DURING) {
            let nextTasksForList = [];
            let seedIdsOnList = [];
            let draggableTasks = [];

            for (let i = 0; i < tasksForList.length; i++) {
                let task = tasksForList[i];

                if (task.start_time) {
                    nextTasksForList.push(task);

                    if (task.seed) {
                        seedIdsOnList.push(task.seed.id)
                    }
                } else {
                    draggableTasks.push(task);
                }
            }

            let nextTasksForDrag = [];

            if (!this.props.seedMode) {
                for (let i = 0; i < draggableTasks.length; i++) {
                    let taskForDrag = draggableTasks[i];

                    if (taskForDrag.seed && seedIdsOnList.indexOf(taskForDrag.seed.id) >= 0) {
                        // A task was seeded with this entry on the main list
                        // We'll hide it from the drag list now
                        continue;
                    }

                    nextTasksForDrag.push(taskForDrag);
                }
            }

            tasksForList = nextTasksForList;
            tasksForDrag = nextTasksForDrag;
        }

        // -------------------------------------------------------------------------------------------------------------

        let canCompleteTasks = this.state.activeTab !== PlannerOverviewScreen.TAB_DURING; // [NoDuringCompletion]

        // -------------------------------------------------------------------------------------------------------------

        let inner = (
            <div id={"PdfRoot"} className={this.state.renderingPdf ? "pdf-rendering" : "pdf-not-rendering"}>

                {!this.props.seedMode && this.state.counts &&
                (
                    <div className={"PlannerOverviewScreen__status"}>
                        <div>

                            {this.state.renderingPdf &&
                            <a href="https://www.rememberme.nl" target="_blank" className={"pdf-embed-logo"}
                               style={{margin: 15, marginBottom: 0, marginTop: 10, marginRight: 0, float: "right", display: "block"}}>
                                <img
                                    style={{height: 64}}
                                    src="data:image/png;base64,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"
                                />
                            </a>
                            }

                            <div className={"PlannerOverviewScreen__status-sub"}>
                                <h2 className={"PlannerOverviewScreen__status-title"}>{this.state.niceTitle}</h2>
                                {this.state.counts.total > 0 && canCompleteTasks &&
                                <p>
                                    <span>Er {this.state.counts.total === 1 ? "is" : "zijn"} in dit onderdeel </span>
                                    <strong><span>{`${this.state.counts.total}`}</span> {this.state.counts.total === 1 ? "taak" : "taken"}
                                    </strong>
                                    <span> aangemaakt, waarvan er </span>
                                    <strong><span>{this.state.counts.completed}</span> voltooid</strong>
                                    <span> {this.state.counts.completed === 1 ? "is" : "zijn"}.</span>
                                </p>
                                }
                                {this.state.counts.total > 0 && !canCompleteTasks &&
                                <p>
                                    <span>Er {this.state.counts.total === 1 ? "is" : "zijn"} </span>
                                    <strong><span>{`${this.state.counts.total}`}</span> {this.state.counts.total === 1 ? "taak" : "taken"}
                                    </strong>
                                    <span> aangemaakt voor de dagplanning.</span>
                                </p>
                                }
                                {this.state.counts.total === 0 &&
                                <p>
                                    Er zijn nog geen taken toegevoegd aan dit onderdeel.
                                </p>
                                }
                            </div>
                        </div>

                        <div style={{clear: "both"}}/>

                        {this.state.counts.total > 0 && canCompleteTasks &&
                        <div className={"PlannerOverviewScreen__status-bar"}>
                            <ProgressIndicator value={this.state.counts.percentage}/>
                        </div>
                        }

                        {!this.state.renderingPdf &&
                        <div className={"PlannerOverviewScreen__status-controls"}>
                            <RmButton label={"Taak toevoegen"}
                                      onClick={this.handleCreateTaskClick.bind(this)}/>
                            <ArrowLink label={"Bekijk de meest voorkomende taken"}
                                       onClick={this.handleTipsClick.bind(this)}/>

                            {this.state.tasks && this.state.tasks.length > 0 &&
                            <ArrowLink label={"Download als PDF bestand"}
                                       onClick={this.handlePdfLinkClick.bind(this)}
                                       icon={<i className={"mdi mdi-file-pdf"}/>}
                            />
                            }
                        </div>
                        }
                    </div>
                )}

                {!this.props.seedMode && !this.state.renderingPdf && this.state.tasks && this.state.tasks.length > 0 &&
                <div>
                    {this.state.activeTab === PlannerOverviewScreen.TAB_DURING &&
                    <div
                        className={"PlannerOverviewScreen__clicktip PlannerOverviewScreen__clicktip--during"}>
                        <i className={"mdi mdi-pencil"}/>
                        {window.ptTouch &&
                        <span>Klik op een taak uit de lijst, of een lege plek op de kalender, om toe te voegen. Klik op een taak op de kalender om deze te bekijken of te wijzigen.</span>
                        }
                        {!window.ptTouch &&
                        <span>Klik op een taak om de details te bekijken of te wijzigen. Sleep een tijdvak of taak op de kalender om toe te voegen.</span>
                        }
                    </div>
                    }
                    {this.state.activeTab !== PlannerOverviewScreen.TAB_DURING &&
                    <div className={"PlannerOverviewScreen__clicktip"}>
                        <i className={"mdi mdi-pencil"}/>
                        <span>Klik op een taak om de details te bekijken of te wijzigen.</span>
                    </div>
                    }
                </div>
                }

                {!this.props.seedMode &&
                <div>
                    {this.state.activeTab === PlannerOverviewScreen.TAB_DURING &&
                    <div className={"PlannerOverviewScreen__day"}>
                        <div className={"PlannerOverviewScreen__day-l"}>
                            <PlannerDayCalendar tasks={this.state.tasks || []}
                                                onTaskClick={this.handleTaskClick.bind(this)}
                                                onPeriodSelectForCreate={this.handlePeriodSelectForCreate.bind(this)}
                                                onEventInsert={this.handleEventInsertOnCal.bind(this)}
                            />
                        </div>
                        {tasksForDrag && tasksForDrag.length > 0 &&
                        <div className={"PlannerOverviewScreen__day-r"}>
                            <PlanItemDragList tasks={tasksForDrag}
                                              onItemSelect={this.handleDragListItemSelected.bind(this)}
                                              value={this.state.selectedDragTask ? this.state.selectedDragTask.id : null}
                            />
                        </div>
                        }
                    </div>
                    }

                    <div className={"PlannerOverviewScreen__content"}>
                        <PlanItemListManaged tasks={tasksForList}
                                             onTaskChecked={this.handleTaskChecked.bind(this)}
                                             onTaskClick={this.handleTaskClick.bind(this)}
                                             onTaskDeleteClicked={this.handleTaskDeleteClick.bind(this)}
                                             hideCompletion={this.state.activeTab === PlannerOverviewScreen.TAB_DURING}
                                             hideControls={this.state.renderingPdf}
                        />
                    </div>
                </div>
                }
            </div>
        );

        return (
            <div>
                {this.state.activeTab &&
                <PlanItemDialog visible={this.state.editTask != null || this.state.creatingTask}
                                periodType={this.state.activeTab} task={this.state.editTask || null}
                                onClose={this.handleEditorClose.bind(this)}
                                onDeleteClicked={this.handleTaskDeleteClick.bind(this, this.state.editTask)}
                                onBackgroundTweenSave={this.handleTaskBgSave.bind(this)}
                                prefillStart={this.state.prefillStart || null}
                                prefillEnd={this.state.prefillEnd || null}
                                prefillText={this.state.prefillText || null}
                                seedTask={this.state.seedTask || null}
                                autoCreate={this.state.autoCreate}
                />
                }

                {this.state.deleteTask &&
                <PlanItemDeleteDialog visible={true} onCancel={this.handleDeleteCancel.bind(this)}
                                      task={this.state.deleteTask}
                                      onComplete={this.handleDeleteComplete.bind(this)}/>
                }

                {this.state.renderingPdf && <div className={"pdf-loading-indicator"}>
                    <i className={"mdi mdi-spin mdi-loading"}/>
                    <p>PDF wordt gegenereerd...</p>
                </div>}

                <PortalScreen tab={"draaiboek_" + this.state.activeTab} title={"Draaiboek"}
                              isLoading={this.state.loadingOverview || this.state.savingSeeds}
                              subText={"Het draaiboek helpt je als nabestaande om alles voorafgaand, tijdens en na de uitvaart goed te organiseren."}>

                    <div className={"PlannerOverviewScreen"}>
                        <Tabber>
                            <TabberTab label={"Voor"}
                                       isActive={this.state.activeTab === PlannerOverviewScreen.TAB_BEFORE}
                                       icon={<i className={"mdi mdi-restore-clock"}/>}
                                       redirectTo={"/draaiboek/voor"}
                            />
                            <TabberTab label={"Tijdens"}
                                       isActive={this.state.activeTab === PlannerOverviewScreen.TAB_DURING}
                                       icon={<i className={"mdi mdi-clock-outline"}/>}
                                       redirectTo={"/draaiboek/tijdens"}
                            />
                            <TabberTab label={"Na"}
                                       isActive={this.state.activeTab === PlannerOverviewScreen.TAB_AFTER}
                                       icon={<i className={"mdi mdi-update"}/>}
                                       redirectTo={"/draaiboek/na"}
                            />
                        </Tabber>
                    </div>

                    {this.props.seedMode &&
                    <div>
                        {!this.state.loadingOverview &&
                        <div className={"PlannerOverviewScreen__seed-header"}>
                            <h2 className={"PlannerOverviewScreen__status-title"}>{this.state.niceTitle}</h2>
                            <p className={"PlannerOverviewScreen__intro"}>Vink aan welke acties je wilt oppakken en
                                creëer op deze manier je eigen actielijst.</p>

                            <div className={"PlannerOverviewScreen__content"}>
                                <PlanItemListManaged tasks={this.state.tasks || []}
                                                     seedMode={true}
                                                     onTaskChecked={this.handleTaskChecked.bind(this)}
                                />
                            </div>

                            <p className={"PlannerOverviewScreen__outro"}>Heb je nog extra acties die hier niet bij
                                staan? Deze kun je in de volgende stap toevoegen.</p>
                        </div>
                        }

                        <RmButton label={"Doorgaan"} onClick={this.handleSeedSaveClick.bind(this)}
                                  busy={this.state.loadingOverview || this.state.savingSeeds}/>
                    </div>
                    }

                    {this.state.renderingPdf &&
                    <PDFExport paperSize={'A4'}
                               scale={.75}
                               fileName={this.pdfName}
                               title={this.state.niceTitle}
                               subject={"RememberMe Draaiboek"}
                               keywords={`rememberme, draaiboek, ${this.state.currentTab}`}
                               ref={(r) => this.refPdf = r}>
                        <PdfFontEmbeds/>
                        <div>{inner}</div>
                    </PDFExport>
                    }

                    {!this.state.renderingPdf &&
                    <div>{inner}</div>
                    }

                </PortalScreen>
            </div>
        );
    }
}

PlannerOverviewScreen.propTypes = {
    seedMode: PropTypes.bool
};

PlannerOverviewScreen.TAB_BEFORE = "voor";
PlannerOverviewScreen.TAB_DURING = "tijdens";
PlannerOverviewScreen.TAB_AFTER = "na";
PlannerOverviewScreen.TAB_DEFAULT = PlannerOverviewScreen.TAB_BEFORE;

PlannerOverviewScreen.NICE_TITLE_MAP = {
    "voor": "Vóór de uitvaart",
    "tijdens": "Tijdens de uitvaart",
    "na": "Na de uitvaart"
};



// WEBPACK FOOTER //
// ./src/Portal/Planner/PlannerOverviewScreen.js